import { useMediaSessionMetadata } from "@/hooks/useMediaSessionMetadata";
import { useMediaSessionActions } from "@/hooks/useMediaSessionActions";

/**
 * Façade combinant metadata + action handlers MediaSession.
 */
export function useMediaSession({
  audioRef,
  currentId,
  radios,
  metaMap,
  isPlaying,
  onZapNext,
  onZapPrev,
}) {
  useMediaSessionMetadata({ currentId, radios, metaMap, isPlaying });
  useMediaSessionActions({ audioRef, onZapNext, onZapPrev });
}
